// extracted by mini-css-extract-plugin
export var wrapper = "SliderControl-module--wrapper--3334e";
export var reverse = "SliderControl-module--reverse--e4ca4";
export var text = "SliderControl-module--text--ac772";
export var buttons = "SliderControl-module--buttons--4beb6";
export var prev = "SliderControl-module--prev--5fdc5";
export var next = "SliderControl-module--next--c0e9b";